






























































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import Detail from '@/components/TransactionTickets/Records/DetailModal.vue';
import Refund from '@/components/TransactionTickets/Records/RefundModal.vue';
import CustomFilter from '@/components/TransactionTickets/Records/Filter.vue';
import DatesFormat from '@/util/classes/datesFormat';
import { risk } from '@/util/transformString/translationsDecorator';
import { VuexFunction } from '@/ts/axios';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { TransactionParams } from '@/store/interfaces/transactions';
import transaction from '@/store/types/transaction';
import { responseDataPagination } from '@/store/interfaces/json-api/generics';
import PaymentMethods from '@/components/Reusable/paymentMethods.vue';
import StatusBadges from '@/components/Reusable/statusBadges.vue';

const formatDate = new DatesFormat();
@Component({
  name: 'MonitorHome',
  components: {
    Detail,
    Refund,
    StatusBadges,
    CustomFilter,
    PaymentMethods,
  },
})
export default class MonitorHome extends Vue {
  query = '';
  viewDetails = false;
  enableRefund = false;
  propsToSearch: tPropsToSearch = [];
  tableColumns: tTableColumns = [
    {
      prop: 'commerce_name',
      label: 'Comercio',
      minWidth: 280,
      sortable: true,
    },
    {
      prop: 'branch_name',
      label: 'Sucursal',
      minWidth: 280,
      sortable: true,
    },
    {
      prop: 'user_name',
      label: 'Usuario',
      minWidth: 280,
      sortable: true,
    },
    {
      prop: 'subtotal_formatted',
      label: 'Subtotal',
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'tip_formatted',
      label: 'Propina',
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'discount_formatted',
      label: 'Descuento',
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'total_formatted',
      label: 'Total',
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'status',
      label: 'Estado',
      minWidth: 150,
      sortable: true,
      slotName: 'status',
    },
    {
      prop: 'kind_name',
      label: 'Tipo de orden',
      minWidth: 130,
    },
    {
      prop: 'card',
      label: 'Método de pago',
      minWidth: 150,
      slotName: 'card',
    },
    {
      prop: 'created_at',
      label: 'Fecha y Hora',
      minWidth: 180,
      sortable: true,
      formatter: (row: TransactionParams): string => {
        return `${formatDate.formatDateTime(row.created_at)}`;
      },
    },
    {
      prop: 'risk',
      label: 'Riesgo',
      minWidth: 100,
      sortable: true,
      formatter: (row: TransactionParams): string => {
        return `${risk(String(row.risk))}`;
      },
    }
  ];

  rowSelected: TransactionParams = {
    authorization_number: '',
    branch_name: '',
    card_last_digits: '',
    biometrics: false,
    card_network: '',
    city_code: '',
    commerce_name: '',
    country_code: '',
    created_at: '',
    discount_cents: 0,
    discount_currency: '',
    order_kind: 'qr',
    kind_name: '',
    discount_formatted: '',
    id: '',
    latitude: '',
    logo: '',
    longitude: '',
    reference_number: '',
    response_code: '',
    risk: '',
    state_code: '',
    status: 'pending',
    subtotal_cents: 0,
    subtotal_currency: '',
    subtotal_formatted: '',
    tip_cents: 0,
    tip_currency: '',
    tip_formatted: '',
    total_cents: 0,
    total_currency: '',
    total_formatted: '',
    updated_at: '',
    user_name: '',
    device_name: '',
    device_platform: '',
    device_version: '',
    device_vendor: '',
    requestable_type: '',
    requestable_id: '',
    user_id: '',
    balance_amount_cents: null,
    balance_amount_currency: null,
    balance_amount_formatted: null,
    card_amount_cents: null,
    card_amount_currency: null,
    card_amount_formatted: null,
    description: '',
    distribution: 'not_assigned',
    expires_at: 1,
  };

  showevent = false;

  // METHODS
  rowselect(row: TransactionParams): void {
    this.rowSelected = row;
  }

  viewDetailsAction(): void {
    this.viewDetails = true;
  }

  viewRefund(): void {
    this.viewDetails = false;
    this.enableRefund = true;
  }

  @Action(
    `transactionModule/${transaction.actions.POSTMORTEM_TRANSACTION_LIST}`
  )
  transactionList!: VuexFunction;

  @Getter(
    `transactionModule/${transaction.getters.GET_POSTMORTEM_TRANSACTIONS}`
  )
  getTransactionList!: responseDataPagination<TransactionParams>;
}
